var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStateInitial = function SvgStateInitial(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.16394C11.4195 2.94535 12.5805 2.94535 13.71 3.16394M13.71 20.8361C12.5805 21.0546 11.4195 21.0546 10.29 20.8361M17.048 4.54902C18.0033 5.19631 18.8252 6.02128 19.469 6.97898M3.16394 13.71C2.94535 12.5805 2.94535 11.4195 3.16394 10.29M19.451 17.048C18.8037 18.0033 17.9787 18.8252 17.021 19.469M20.8361 10.29C21.0546 11.4195 21.0546 12.5805 20.8361 13.71M4.54902 6.95198C5.19631 5.99667 6.02128 5.17476 6.97898 4.53102M6.95198 19.451C5.99667 18.8037 5.17476 17.9787 4.53102 17.021",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStateInitial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "state-initial.6596cfd1a21aacd00a986f85d072e090.svg";